import axios from 'axios';

const clientExternalConfirmCancel = async ({
  appointmentId,
  status,
  details,
  isPending = false,
  dashboardId,
}: {
  appointmentId: string;
  status: 'confirm' | 'cancel' | 'deny';
  details?: string;
  isPending?: boolean;
  dashboardId: string;
}) => {
  const { data } = await axios.post(`/external/dash/${dashboardId}/status`, {
    status,
    details,
    isPending,
    appointmentId,
  });
  return data;
};

export default clientExternalConfirmCancel;
